import { render } from "./list.vue?vue&type=template&id=10762162"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=10762162&lang=scss"

import exportComponent from "D:\\Git\\思途茶业\\思途茶业pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__